'use client';

import { CheckCircle2 } from 'lucide-react';
import { Display, Reveal, GlassCard } from '../ui';
import { ChatSearchMock } from '../mockups';

// Accurate to the product: keyword + semantic search over transcribed moments.
const checks = [
  'Keyword + semantic search across every moment',
  'Sub-second response times',
  'Instant MomentCard previews',
];

export default function TalkToFootageSection() {
  return (
    <section id="talk" className="bg-mk-s-low px-6 py-28">
      <div className="mx-auto grid max-w-[1280px] grid-cols-1 items-center gap-16 md:grid-cols-2">
        <Reveal>
          <Display className="mb-6 text-5xl sm:text-6xl">
            Talk to your footage.
          </Display>
          <p className="mb-8 font-mk-body text-lg text-mk-muted">
            No filters. No scrubbing. Just ask. Reclipt understands your query
            and finds the exact moment in seconds.
          </p>
          <div className="space-y-4">
            {checks.map((c) => (
              <div key={c} className="flex items-start gap-4">
                <CheckCircle2 className="mt-0.5 h-5 w-5 flex-shrink-0 text-mk-pink" />
                <p className="font-mk-body text-mk-ink">{c}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <GlassCard className="border-mk-pink/20 p-6 shadow-mk-neon-lg">
            <ChatSearchMock />
          </GlassCard>
        </Reveal>
      </div>
    </section>
  );
}
